import React, { useEffect, useState, useRef } from 'react';
import { MessageSquare } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const scrollTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const lastScrollY = useRef(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const isScrollingDown = currentY > lastScrollY.current && currentY > 100;
      lastScrollY.current = currentY;
      if (isScrollingDown) {
        setVisible(true);
      }
      // Clear existing timeout
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      // Hide after 1 second of no scrolling
      scrollTimeoutRef.current = setTimeout(() => {
        setVisible(false);
      }, 1000);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);
  return <AnimatePresence data-id="element-1074">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden flex" data-id="element-1075">
          <a href="sms:206-619-3742" className="flex-1 flex items-center justify-center py-3.5 bg-[#3d3d3d] text-white font-bold text-sm border-t border-[#4a4a4a]" data-id="element-1076">
            <MessageSquare className="w-4 h-4 mr-2 text-brand-orange" data-id="element-1077" />
            Start Chat
          </a>
        </motion.div>}
    </AnimatePresence>;
}